import Hero from '@/components/sections/Hero';
import DualEntryPath from '@/components/DualEntryPath';
import Problem from '@/components/sections/Problem';
import Reframe from '@/components/sections/Reframe';
import Method from '@/components/sections/Method';
import AsyncDelivery from '@/components/sections/AsyncDelivery';
import ForNotFor from '@/components/sections/ForNotFor';
import ProofBlock from '@/components/sections/ProofBlock';
import OfferArchitecture from '@/components/sections/OfferArchitecture';
import FounderSection from '@/components/sections/FounderSection';
import FinalCTA from '@/components/sections/FinalCTA';

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <main>
        <Hero />
        <DualEntryPath />
        <div id="problem-section-anchor">
          <Problem />
        </div>
        <Reframe />
        <Method />
        <AsyncDelivery />
        <ForNotFor />
        <ProofBlock />
        <OfferArchitecture />
        <FounderSection />
        <FinalCTA />
      </main>
    </div>
  );
};

export default HomePage;
